/**
 * created by zhengzihang
 * 统一拦截设置
 */
import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';

// 创建axios请求实例
function createAxiosInstance () {
	const instance = axios.create({
	    timeout: 30000,
	    headers: {
	      'Content-Type': 'application/x-www-form-urlencoded',
	    }
	 });
	// 查询参数
	const queryParam = {
  	deviceId: '5a4c935cbb6ff6ca',
  	deviceType: 'SM-G9300',
  	timestamp: new Date().getTime(),
  	app: 0,
  	platform: 3,
  	app_key: 'PAHealth',
  	osversion: 23,
  	version: '1.0.1',
  	resolution: '1440x2560',
  	screenSize: '22',
  	netType: '1',
  	channel: 'bd_h5'
  }
  // 请求拦截
	instance.interceptors.request.use(config => {
		// 拼装url，携带查询参数
		//config.url = `${config.url}?${qs.stringify(queryParam)}`
		config.data = Object.assign({}, queryParam, config.data)
		// 请求体业务参数
		config.data = qs.stringify(config.data);
		return config
	});
	instance.interceptors.response.use(response => {
		if (response.config.responseType == 'blob') {
      return response
    }
		if (response.status === 200) {
			return response.data
		} else {
			window.toast && window.toast.hide()
			Promise.reject(response.data)
		}
	}, error => {
		window.toast && window.toast.hide()
		Promise.reject(error)
	})
	return instance;
}

export default createAxiosInstance

